import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Redo = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.95089 13.2576C5.07115 8.28247 11.2227 6.47626 14.8548 10.056L17.9775 13.1336L17.9774 9.67156C17.9774 9.39542 18.2013 9.17156 18.4774 9.17156C18.7536 9.17156 18.9774 9.39542 18.9774 9.67156L18.9775 14.3284C18.9775 14.461 18.9248 14.5882 18.831 14.682C18.7372 14.7758 18.6101 14.8284 18.4775 14.8284L13.8206 14.8284C13.5444 14.8284 13.3206 14.6046 13.3206 14.3284C13.3206 14.0523 13.5444 13.8284 13.8206 13.8284L17.2578 13.8284L14.1529 10.7682C11.0796 7.73921 5.87438 9.26754 4.92647 13.4772L4.71313 14.4247C4.65247 14.6941 4.38491 14.8633 4.11551 14.8026C3.84611 14.742 3.6769 14.4744 3.73756 14.205L3.95089 13.2576Z"
      />
    </svg>
  )
})

export default Redo
